import { useMutation } from "@tanstack/react-query";
import api from "../lib/apiClient";

export const useEnroll = () => {
	return useMutation({
		mutationFn: async (payload) => {
		const { data } = await api.post("/enroll", payload);
		return data;
		},
	});
};